export default __webpack_public_path__ + "static/media/step6_poi_image1.0437e09a.jpg";